/**
 * Created by rathompson on 5/10/22
 * File: CellRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { Body, Tooltip } from '@panwds/react-ui'

const CellRenderer = ({ row, value }) => {
  const { original: { disabled = false, reason } } = row
  if (disabled) {
    return <Tooltip label={reason}>
      <div className='tw-h-full tw-truncate'>
        <Body size="lg" addClassName='tw-truncate tw-text-disabled'>{value}</Body>
      </div>
    </Tooltip>
  }
  return (<div className='tw-h-full tw-truncate'>
    <Body size="lg" addClassName='tw-truncate'>{value}</Body>
  </div>)
}
export default CellRenderer
